module.exports = __webpack_public_path__ + "img/27.67c5b824.svg";